import { BRAND } from "@/lib/site";

const DEFAULT_MESSAGE = `Hello ${BRAND.name},

I found your website and I'm interested in wedding photography services.

I would like to know more about your availability and packages.

Please assist me.

Thank you.`;

// Build a WhatsApp click-to-chat URL with a prefilled message.
export function whatsappUrl(message) {
  const text = encodeURIComponent(message || DEFAULT_MESSAGE);
  return `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
}

// Context-aware prefilled messages so every CTA feels intentional.
export const WA = {
  popup: () =>
    whatsappUrl(
      `Hello ${BRAND.name},\n\nI would like to know more about your wedding photography and cinematography services.\n\nPlease share your packages and availability.`
    ),
  general: () => whatsappUrl(DEFAULT_MESSAGE),
  consultation: () =>
    whatsappUrl(
      `Hello ${BRAND.name},\n\nI would love to book a consultation for wedding photography & films.\n\nMy approximate wedding date is ____ and the city is ____.\n\nPlease share your availability and packages.\n\nThank you.`
    ),
  availability: () =>
    whatsappUrl(
      `Hello ${BRAND.name},\n\nI'd like to check your availability for my wedding.\n\nDate: ____\nCity: ____\n\nThank you.`
    ),
  service: (serviceName) =>
    whatsappUrl(
      `Hello ${BRAND.name},\n\nI'm interested in your "${serviceName}" service.\n\nI'd love to know more about packages and availability.\n\nThank you.`
    ),
  story: (coupleName) =>
    whatsappUrl(
      `Hello ${BRAND.name},\n\nI loved the wedding story of ${coupleName} on your website.\n\nI'd like to create something similar for my wedding. Please share your availability and packages.\n\nThank you.`
    ),
  phone: (number) => `tel:+91${number}`,
  mail: () => `mailto:${BRAND.email}`,
};
